// Configuración por variables de entorno (CRA solo expone REACT_APP_*).
// Archivos: .env.development (yarn start), .env.production (yarn build / yarn prod)
// y .env.example como referencia. Sin variable definida se usa el entorno local.
export const backend =
  process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000/api/v1';

// Base WebSocket derivada del backend (misma host, sin el prefijo /api/v1),
// o explícita con REACT_APP_WS_URL.
export const wsBackend =
  process.env.REACT_APP_WS_URL ||
  backend.replace(/^http/, 'ws').replace(/\/api\/v1\/?$/, '');
